import { useLeague } from '../utils/LeagueContext';

const AcceptDeclineInviteEmpty = ({ entity = 'data', className }) => {
  const { selectedLeague } = useLeague();

  if (!selectedLeague || !selectedLeague._id) return null;

  return (
    <div>
      {/* Empty div on purpose */}
    </div>
  );
};

export default AcceptDeclineInviteEmpty;
